import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dad2a03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_6 = { class: "ss-tela-titulo" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Antecipação de Títulos a Receber", -1))
const _hoisted_8 = { class: "atalhos" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Remover dos Meus Atalhos", -1))
const _hoisted_10 = {
  style: {"color":"orange","font-size":"20px"},
  class: "anticon"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adicionar aos Meus Atalhos", -1))
const _hoisted_12 = { class: "anticon" }
const _hoisted_13 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-8",
  style: {"padding-top":"4px"}
}
const _hoisted_14 = { class: "ant-btn-group ss-tamanho-completo" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Concluir Antecipação", -1))
const _hoisted_16 = { class: "ss-tela-conteudo" }
const _hoisted_17 = { class: "ss-card ss-card-space" }
const _hoisted_18 = { class: "ant-row ss-ocultar-mobile" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESA")
], -1))
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-17" }
const _hoisted_24 = { class: "ant-col ant-col-xs-20 ant-col-xl-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "O valor da taxa será calculado utilizando o percentual definido no cadastro de cada cliente, caso não houver será utilizado o percentual abaixo.", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Selecione os títulos que deseja Antecipar", -1))
const _hoisted_27 = {
  class: "ant-row",
  style: {"margin-bottom":"15px"}
}
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_29 = { class: "ant-input-wrapper ant-input-group ss-alinhar-texto-esquerda" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ant-input-group-addon" }, "NÚMERO TÍTULO:", -1))
const _hoisted_31 = ["title"]
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 3 }
const _hoisted_34 = {
  key: 4,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Título:", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Taxa:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor Total:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-divider ant-divider-horizontal",
  role: "separator",
  style: {"margin-bottom":"10px"}
}, null, -1))
const _hoisted_44 = {
  class: "ant-row",
  style: {"padding-left":"5px","padding-bottom":"5px"}
}
const _hoisted_45 = { class: "ant-row" }
const _hoisted_46 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_47 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_48 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Recebimento normal", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Alteração de conta", -1))
const _hoisted_52 = { class: "ant-row" }
const _hoisted_53 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"left"} }, "\"Deseja alterar a Conta de origem dos títulos?\"", -1))
const _hoisted_55 = {
  key: 0,
  class: "ant-col ant-col-xs-12 ant-col-xl-12"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-align":"left"} }, "Nova Conta dos títulos", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Prévia da Antecipação", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ss-titulo-lancamentos-baixa" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Baseado nas informações fornecidas serão criadas as seguintes Movimentações de Contas:")
], -1))
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { key: 2 }
const _hoisted_62 = { key: 3 }
const _hoisted_63 = { key: 4 }
const _hoisted_64 = { key: 5 }
const _hoisted_65 = { key: 6 }
const _hoisted_66 = { key: 7 }
const _hoisted_67 = {
  key: 8,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data:", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tipo Movimento:"),
  /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString('Antecipação de títulos'))
], -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Identificador:", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Descrição:", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor:", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Influência Saldo:", -1))
const _hoisted_75 = { class: "ant-row" }
const _hoisted_76 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_77 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_78 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_79 = { class: "ss-alinhar-texto-esquerda" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_selecionar_titulo_financeiro_por_numero = _resolveComponent("selecionar-titulo-financeiro-por-numero")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_baixa_titulos_lancamento = _resolveComponent("baixa-titulos-lancamento")!
  const _component_selecionar_sim_nao = _resolveComponent("selecionar-sim-nao")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_buscar_titulos_modal = _resolveComponent("buscar-titulos-modal")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.storeSistema.getters.atalhoAdicionado(_ctx.antecipacaoTitulosBase.identificadorRecurso, [_ctx.antecipacaoTitulosBase.empresaSelecionada]))
                    ? (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 0,
                        placement: "bottom"
                      }, {
                        title: _withCtx(() => [
                          _hoisted_9
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removerAtalho(_ctx.antecipacaoTitulosBase.identificadorRecurso, [_ctx.antecipacaoTitulosBase.empresaSelecionada])))
                          }, [
                            _createElementVNode("i", _hoisted_10, [
                              _createVNode(_component_icone, { nome: "estrela" })
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_tooltip, {
                        key: 1,
                        placement: "bottom"
                      }, {
                        title: _withCtx(() => [
                          _hoisted_11
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adicionarAtalho(_ctx.antecipacaoTitulosBase.identificadorRecurso, [_ctx.antecipacaoTitulosBase.empresaSelecionada])))
                          }, [
                            _createElementVNode("i", _hoisted_12, [
                              _createVNode(_component_icone, { nome: "favorito" })
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-block",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmacaoLimparTela()))
                }, " Cancelar "),
                (_ctx.verificarConclusaoAntecipacao())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "ant-btn ant-btn-primary ss-btn-tela ant-btn-block",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmacaoAntecipacao()))
                    }, [
                      _createVNode(_component_icone, { nome: "correto" }),
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_a_select, {
                        class: "ss-tamanho-completo",
                        value: _ctx.antecipacaoTitulosBase.empresaSelecionada,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.antecipacaoTitulosBase.empresaSelecionada) = $event)),
                        options: _ctx.telaBase.empresasDisponiveis,
                        optionFilterProp: "label",
                        onChange: _ctx.atualizarSelecaoEmpresas
                      }, null, 8, ["value", "options", "onChange"])
                    ])
                  ]),
                  _createVNode(_component_a_spin, {
                    spinning: _ctx.antecipacaoTitulosBase.carregandoParametros
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_a_form_item, { label: "Data da Antecipação" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_data, {
                                dataSelecionada: _ctx.antecipacaoTitulosBase.dataAntecipacao,
                                "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.antecipacaoTitulosBase.dataAntecipacao) = $event)),
                                horaMinuto: true,
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.verificacaoAlteracaoData()))
                              }, null, 8, ["dataSelecionada"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_a_form_item, {
                            label: "Categoria - Taxas",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_categoria_plano_conta, {
                                codigoSelecionado: _ctx.antecipacaoTitulosBase.categoriaPadraoTaxas,
                                "onUpdate:codigoSelecionado": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.antecipacaoTitulosBase.categoriaPadraoTaxas) = $event)),
                                empresas: [_ctx.antecipacaoTitulosBase.empresaSelecionada]
                              }, null, 8, ["codigoSelecionado", "empresas"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                            label: _withCtx(() => [
                              _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                title: _withCtx(() => [
                                  _hoisted_25
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_checkbox, {
                                    checked: _ctx.antecipacaoTitulosBase.percentualTaxa,
                                    "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.antecipacaoTitulosBase.percentualTaxa) = $event)),
                                    disabled: !_ctx.antecipacaoTitulosBase.alteracaoPercentuais,
                                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.verificacaoCalculo()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Taxa - Antecipação")
                                    ]),
                                    _: 1
                                  }, 8, ["checked", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                percentual: true,
                                valor: _ctx.antecipacaoTitulosBase.percentualTaxa,
                                "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.antecipacaoTitulosBase.percentualTaxa) = $event)),
                                disabled: !_ctx.antecipacaoTitulosBase.alteracaoPercentuais,
                                onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.calcularValores(true)))
                              }, null, 8, ["valor", "disabled"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["spinning"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_collapse, {
              activeKey: _ctx.antecipacaoTitulosBase.passoAtivo,
              "onUpdate:activeKey": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.antecipacaoTitulosBase.passoAtivo) = $event)),
              accordion: "",
              onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.verificarPassos()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "1",
                  collapsible: _ctx.antecipacaoTitulosBase.carregandoParametros?'disabled':''
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode("1º Passo")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_26
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, [
                          _hoisted_30,
                          _createVNode(_component_selecionar_titulo_financeiro_por_numero, {
                            empresas: [_ctx.antecipacaoTitulosBase.empresaSelecionada],
                            tipoTitulo: _ctx.ETipoTituloFinanceiro.Receber,
                            dispararEventoSelecionarTitulo: true,
                            apenasTitulosPendentes: true,
                            codigoSelecionado: _ctx.antecipacaoTitulosBase.codigoTituloPesquisa,
                            "onUpdate:codigoSelecionado": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.antecipacaoTitulosBase.codigoTituloPesquisa) = $event)),
                            placeholder: 'Digite o número do título que deseja adicionar',
                            onTitulosSelecionados: _cache[13] || (_cache[13] = ($event: any) => (_ctx.populartitulosAntecipados($event)))
                          }, null, 8, ["empresas", "tipoTitulo", "codigoSelecionado"])
                        ])
                      ])
                    ]),
                    _createVNode(_component_card, {
                      class: "ss-card-alinhado",
                      titulo: "TÍTULOS ADICIONADOS NA ANTECIPACAO"
                    }, {
                      AcoesExtra: _withCtx(() => [
                        _createElementVNode("a", {
                          class: "ss-fonte-negrito ss-card-botao-acao-extra",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.buscarTitulos()))
                        }, "BUSCAR TÍTULOS")
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_table, {
                          columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                          "data-source": _ctx.antecipacaoTitulosBase.titulosAntecipados,
                          rowKey: "codigoTituloFinanceiro",
                          pagination: false,
                          loading: _ctx.telaBase.carregando,
                          scroll: _ctx.gradeBase.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth +150), y: 500 },
                          "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
                          size: "small"
                        }, {
                          headerCell: _withCtx(({ column }) => [
                            _createVNode(_component_coluna_grade, {
                              column: column,
                              ordenacaoSelecionada: _ctx.telaBase.ordenacaoSelecionada,
                              "onUpdate:ordenacaoSelecionada": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                              filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
                              "onUpdate:filtrosCabecalho": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
                              onBuscarDados: _cache[17] || (_cache[17] = ($event: any) => (_ctx.buscarTitulos()))
                            }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho"])
                          ]),
                          bodyCell: _withCtx(({ column, record, text, index }) => [
                            (column.key === 'TipoDocumentoFinanceiro')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  title: record.descricaoTipoDocumentoFinanceiro
                                }, _toDisplayString(record.siglaTipoDocumentoFinanceiro), 9, _hoisted_31))
                              : (column.key === 'ValorTaxa')
                                ? (_openBlock(), _createBlock(_component_campo_numerico, {
                                    key: 1,
                                    dataAttributeColuna: column.key,
                                    valor: record.valorJurosMulta,
                                    "onUpdate:valor": ($event: any) => ((record.valorJurosMulta) = $event),
                                    onValorDigitado: ($event: any) => (_ctx.valorTaxaDigitado(index)),
                                    classCss: "ss-campo-numero-table ss-baixa-contas-receber-titulos-adicionados",
                                    onKeydown: [
                                      _cache[18] || (_cache[18] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["tab"])),
                                      _cache[19] || (_cache[19] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent","exact"]), ["enter"])),
                                      _cache[20] || (_cache[20] = _withKeys(_withModifiers(($event: any) => (_ctx.elementoAnterior($event)), ["prevent"]), ["left"])),
                                      _cache[21] || (_cache[21] = _withKeys(_withModifiers(($event: any) => (_ctx.proximoElemento($event)), ["prevent"]), ["right"])),
                                      _withKeys(_withModifiers(($event: any) => (_ctx.elementoAbaixo($event,column.key)), ["prevent"]), ["down"]),
                                      _withKeys(_withModifiers(($event: any) => (_ctx.elementoAcima($event,column.key)), ["prevent"]), ["up"])
                                    ]
                                  }, null, 8, ["dataAttributeColuna", "valor", "onUpdate:valor", "onValorDigitado", "onKeydown"]))
                                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text,2)), 1))
                                    : (column.key === 'TituloFinanceiro')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                          _createElementVNode("span", null, [
                                            _hoisted_35,
                                            _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' + record.descricaoTipoDocumentoFinanceiro), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_36,
                                            _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_37,
                                            _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_38,
                                            _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_39,
                                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo,2)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_40,
                                            _createTextVNode(),
                                            _createVNode(_component_campo_numerico, {
                                              monetario: true,
                                              valor: record.valorJurosMulta,
                                              "onUpdate:valor": ($event: any) => ((record.valorJurosMulta) = $event),
                                              onValorDigitado: ($event: any) => (_ctx.valorTaxaDigitado(index)),
                                              classCss: "ss-campo-numero-table"
                                            }, null, 8, ["valor", "onUpdate:valor", "onValorDigitado"])
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_41,
                                            _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.valorTotal,2)), 1)
                                          ]),
                                          _createElementVNode("span", null, [
                                            _hoisted_42,
                                            _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                          ]),
                          emptyText: _withCtx(() => [
                            (_ctx.antecipacaoTitulosBase.titulosAntecipados.length <= 0)
                              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                  key: 0,
                                  mensagem: "Nenhum título adicionado ainda"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
                        _hoisted_43,
                        _createElementVNode("div", _hoisted_44, [
                          ((_ctx.gradeBase.codigosSelecionados.length > 0))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "ant-btn ant-btn-secondary",
                                style: {"margin-right":"5px"},
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.removerTitulosMarcados()))
                              }, "Remover Selecionados"))
                            : _createCommentVNode("", true),
                          ((_ctx.antecipacaoTitulosBase.titulosAntecipados.length > 0))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "ant-btn ant-btn-secondary",
                                style: {"margin-left":"5px"},
                                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.removerTodosTitulos()))
                              }, "Remover Todos"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, {
                      class: "ss-card-alinhado",
                      titulo: "TOTALIZADORES"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_totalizador, {
                              titulo: "QTDE TÍTULOS",
                              monetario: false,
                              valor: _ctx.antecipacaoTitulosBase.titulosAntecipados.length,
                              casasDecimais: 0
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL TÍTULOS",
                              monetario: true,
                              valor: _ctx.antecipacaoTitulosBase.totalTitulos
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL TAXAS",
                              monetario: true,
                              valor: _ctx.antecipacaoTitulosBase.totalTaxas
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Total dos Títulos - Taxas"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_totalizador, {
                                  titulo: "TOTAL TÍTULOS (- Taxas)",
                                  monetario: true,
                                  valor: _ctx.antecipacaoTitulosBase.totalFinal
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["collapsible"]),
                _createVNode(_component_a_collapse_panel, {
                  key: "2",
                  collapsible: _ctx.antecipacaoTitulosBase.titulosAntecipados.length > 0?'':'disabled'
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 2° Passo ")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_50
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_baixa_titulos_lancamento, {
                      empresa: _ctx.antecipacaoTitulosBase.empresaSelecionada,
                      tituloApresentacao: 'Recebimento',
                      dataBaixa: _ctx.antecipacaoTitulosBase.dataAntecipacao,
                      totalBaixa: _ctx.antecipacaoTitulosBase.totalAntecipacao,
                      contaPadrao: _ctx.antecipacaoTitulosBase.contaPadrao,
                      lancamentos: _ctx.antecipacaoTitulosBase.lancamentosContaNormais,
                      "onUpdate:lancamentos": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.antecipacaoTitulosBase.lancamentosContaNormais) = $event)),
                      totalLancamentos: _ctx.antecipacaoTitulosBase.totalLancamentosContaNormais,
                      "onUpdate:totalLancamentos": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.antecipacaoTitulosBase.totalLancamentosContaNormais) = $event))
                    }, null, 8, ["empresa", "dataBaixa", "totalBaixa", "contaPadrao", "lancamentos", "totalLancamentos"])
                  ]),
                  _: 1
                }, 8, ["collapsible"]),
                _createVNode(_component_a_collapse_panel, {
                  key: "3",
                  collapsible: _ctx.antecipacaoTitulosBase.titulosAntecipados.length > 0?'':'disabled'
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode("3º Passo")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_51
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createVNode(_component_selecionar_sim_nao, {
                          radioButton: true,
                          valor: _ctx.state.alterarConta,
                          "onUpdate:valor": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.alterarConta) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      (_ctx.state.alterarConta)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _hoisted_56,
                            _createVNode(_component_selecionar_conta, {
                              codigoSelecionado: _ctx.state.novaConta,
                              "onUpdate:codigoSelecionado": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.novaConta) = $event)),
                              descricaoSelecionado: _ctx.state.descricaoNovaConta,
                              "onUpdate:descricaoSelecionado": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.descricaoNovaConta) = $event)),
                              empresas: _ctx.telaBase.empresasSelecionadas,
                              style: {"width":"100%"}
                            }, null, 8, ["codigoSelecionado", "descricaoSelecionado", "empresas"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["collapsible"]),
                _createVNode(_component_a_collapse_panel, {
                  key: "4",
                  collapsible: (_ctx.antecipacaoTitulosBase.totalTitulosLancados > 0 || _ctx.antecipacaoTitulosBase.totalLancamentosContaNormais > 0)?'':'disabled'
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Confirmação")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(),
                    _hoisted_57
                  ]),
                  default: _withCtx(() => [
                    _hoisted_58,
                    _createVNode(_component_card, { class: "ss-card-alinhado" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_table, {
                          columns: _ctx.antecipacaoTitulosBase.colunasMovimentos.filter(item => item.visible),
                          "data-source": _ctx.antecipacaoTitulosBase.movimentosFinanceiros,
                          pagination: false,
                          loading: _ctx.telaBase.carregando,
                          size: "small"
                        }, {
                          bodyCell: _withCtx(({ column, record }) => [
                            (column.key === 'Conta')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.obterDescricaoConta(record.movimentoFinanceiro.codigoConta)), 1))
                              : (column.key === 'DataMovimento')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.movimentoFinanceiro.dataMovimento)), 1))
                                : (column.key === 'DescricaoTipoMovimento')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString('Antecipação de Títulos')))
                                  : (column.key === 'IdentificadorMovimento')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(record.movimentoFinanceiro.identificadorMovimento), 1))
                                    : (column.key === 'DescricaoMovimento')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(record.movimentoFinanceiro.descricao), 1))
                                      : (column.key === 'ValorMovimento')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.movimentoFinanceiro.valor,2)), 1))
                                        : (column.key === 'NovaConta')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.state.descricaoNovaConta), 1))
                                          : (column.key === 'InfluenciaSaldo')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.obterDescricaoInfluenciaSaldo(record.movimentoFinanceiro.influenciaSaldo)), 1))
                                            : (column.key === 'MovimentoBaixa')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                                  _createElementVNode("span", null, [
                                                    _hoisted_68,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.obterDescricaoConta(record.movimentoFinanceiro.codigoConta)), 1)
                                                  ]),
                                                  _createElementVNode("span", null, [
                                                    _hoisted_69,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.movimentoFinanceiro.dataMovimento)), 1)
                                                  ]),
                                                  _hoisted_70,
                                                  _createElementVNode("span", null, [
                                                    _hoisted_71,
                                                    _createTextVNode(" " + _toDisplayString(record.movimentoFinanceiro.identificadorMovimento), 1)
                                                  ]),
                                                  _createElementVNode("span", null, [
                                                    _hoisted_72,
                                                    _createTextVNode(" " + _toDisplayString(record.movimentoFinanceiro.descricao), 1)
                                                  ]),
                                                  _createElementVNode("span", null, [
                                                    _hoisted_73,
                                                    _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.movimentoFinanceiro.valor,2)), 1)
                                                  ]),
                                                  _createElementVNode("span", null, [
                                                    _hoisted_74,
                                                    _createTextVNode(" " + _toDisplayString(_ctx.obterDescricaoInfluenciaSaldo(record.movimentoFinanceiro.influenciaSaldo)), 1)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                          ]),
                          emptyText: _withCtx(() => [
                            (_ctx.antecipacaoTitulosBase.movimentosFinanceiros.length <= 0)
                              ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                  key: 0,
                                  mensagem: "Nenhum lançamento adicionado ainda"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, {
                      class: "ss-card-alinhado",
                      titulo: "RESUMO DOS MOVIMENTOS"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL TAXAS",
                              monetario: true,
                              valor: _ctx.antecipacaoTitulosBase.totalTaxas
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_77, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL MOVIMENTOS",
                              monetario: true,
                              valor: _ctx.antecipacaoTitulosBase.totalMovimentoFinal
                            }, null, 8, ["valor"])
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _createVNode(_component_totalizador, {
                              titulo: "TOTAL ANTECIPACAO",
                              monetario: true,
                              valor: _ctx.antecipacaoTitulosBase.totalAntecipacao
                            }, null, 8, ["valor"])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_79, [
                      (_ctx.antecipacaoTitulosBase.alertaBaixa.visivel)
                        ? (_openBlock(), _createBlock(_component_a_alert, {
                            key: 0,
                            message: _ctx.antecipacaoTitulosBase.alertaBaixa.titulo,
                            description: _ctx.antecipacaoTitulosBase.alertaBaixa.mensagem,
                            type: _ctx.antecipacaoTitulosBase.alertaBaixa.tipo,
                            "show-icon": ""
                          }, null, 8, ["message", "description", "type"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["collapsible"])
              ]),
              _: 1
            }, 8, ["activeKey"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_buscar_titulos_modal, {
      visivel: _ctx.antecipacaoTitulosBase.exibirBuscaTitulos,
      "onUpdate:visivel": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.antecipacaoTitulosBase.exibirBuscaTitulos) = $event)),
      empresa: _ctx.antecipacaoTitulosBase.empresaSelecionada,
      tipoTitulo: _ctx.ETipoTituloFinanceiro.Receber,
      apenasTitulosPendentes: true,
      omitirTitulos: _ctx.antecipacaoTitulosBase.titulosAntecipados.map(c=>c.codigoTituloFinanceiro),
      onConfirmacao: _cache[32] || (_cache[32] = ($event: any) => (_ctx.populartitulosAntecipados($event)))
    }, null, 8, ["visivel", "empresa", "tipoTitulo", "omitirTitulos"]),
    _createVNode(_component_requisicao_modal, {
      visivel: _ctx.modalBase.exibirRequisicaoModal,
      "onUpdate:visivel": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
      retornoRequisicao: _ctx.modalBase.retornoRequisicao,
      apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
    }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
  ], 64))
}